import './emoji.scss';
import './emoji-feishu.scss';

let emojiCodes = [
    { text: '微笑', index: 0, code: '/::)', regcode: '/::\\)', regtext: '\\[微笑\\]' },
    { text: '伤心', index: 1, code: '/::~', regcode: '/::~', regtext: '\\[伤心\\]' },
    { text: '美女', index: 2, code: '/::B', regcode: '/::B', regtext: '\\[美女\\]' },
    { text: '发呆', index: 3, code: '/::|', regcode: '/::\\|', regtext: '\\[发呆\\]' },
    { text: '墨镜', index: 4, code: '/:8-)', regcode: '/:8\\-\\)', regtext: '\\[墨镜\\]' },
    // { text: "哭泣", index: 5, code: "/::<", regcode: "/::<", regtext: "\\[哭泣\\]" },
    { text: '羞', index: 6, code: '/::$', regcode: '/::\\$', regtext: '\\[羞\\]' },
    { text: '哑', index: 7, code: '/::X', regcode: '/::X', regtext: '\\[哑\\]' },
    { text: '睡', index: 8, code: '/::Z', regcode: '/::Z', regtext: '\\[睡\\]' },
    { text: '大哭', index: 9, code: "/::'(", regcode: "/::'\\(", regtext: '\\[大哭\\]' },
    { text: '尴尬', index: 10, code: '/::-|', regcode: '/::\\-\\|', regtext: '\\[尴尬\\]' },
    { text: '怒', index: 11, code: '/::@', regcode: '/::@', regtext: '\\[怒\\]' },
    { text: '调皮', index: 12, code: '/::P', regcode: '/::P', regtext: '\\[调皮\\]' },
    { text: '笑', index: 13, code: '/::D', regcode: '/::D', regtext: '\\[笑\\]' },
    { text: '惊讶', index: 14, code: '/::O', regcode: '/::O', regtext: '\\[惊讶\\]' },
    { text: '难过', index: 15, code: '/::(', regcode: '/::\\(', regtext: '\\[难过\\]' },
    { text: '酷', index: 16, code: '/:: ', regcode: '/:: ', regtext: '\\[酷\\]' },
    { text: '囧', index: 17, code: '/:--b', regcode: '/:--b', regtext: '\\[囧\\]' },
    { text: '抓狂', index: 18, code: '/::Q', regcode: '/::Q', regtext: '\\[抓狂\\]' },
    { text: '吐', index: 19, code: '/::T', regcode: '/::T', regtext: '\\[吐\\]' },
    { text: '偷笑', index: 20, code: '/:,@P', regcode: '/:,@P', regtext: '\\[偷笑\\]' },
    { text: '快乐', index: 21, code: '/:,@-D', regcode: '/:,@\\-D', regtext: '\\[快乐\\]' },
    { text: '白眼', index: 22, code: '/::d', regcode: '/::d', regtext: '\\[白眼\\]' },
    { text: '撇嘴', index: 23, code: '/:,@o', regcode: '/:,@o', regtext: '\\[撇嘴\\]' },
    { text: '饿', index: 24, code: '/::g', regcode: '/::g', regtext: '\\[饿\\]' },
    { text: '困', index: 25, code: '/:|-)', regcode: '/:\\|\\-\\)', regtext: '\\[困\\]' },
    { text: '惊吓', index: 26, code: '/::!', regcode: '/::!', regtext: '\\[惊吓\\]' },
    { text: '流汗', index: 27, code: '/::L', regcode: '/::L', regtext: '\\[流汗\\]' },
    { text: '大笑', index: 28, code: '/::>', regcode: '/::>', regtext: '\\[大笑\\]' },
    { text: '抽烟', index: 29, code: '/::,@', regcode: '/::,@', regtext: '\\[抽烟\\]' },
    { text: '奋斗', index: 30, code: '/:,@f', regcode: '/:,@f', regtext: '\\[奋斗\\]' },
    { text: '咒骂', index: 31, code: '/::-S', regcode: '/::\\-S', regtext: '\\[咒骂\\]' },
    { text: '疑问', index: 32, code: '/:?', regcode: '/:\\?', regtext: '\\[疑问\\]' },
    { text: '秘密', index: 33, code: '/:,@x', regcode: '/:,@x', regtext: '\\[秘密\\]' },
    { text: '晕', index: 34, code: '/:,@@', regcode: '/:,@@', regtext: '\\[晕\\]' },
    { text: '发疯', index: 35, code: '/::8', regcode: '/::8', regtext: '\\[发疯\\]' },
    { text: '衰', index: 36, code: '/:,@!', regcode: '/:,@!', regtext: '\\[衰\\]' },
    { text: '骷髅', index: 37, code: '/:!!!', regcode: '/:!!!', regtext: '\\[骷髅\\]' },
    { text: '敲打', index: 38, code: '/:xx', regcode: '/:xx', regtext: '\\[敲打\\]' },
    { text: '再见', index: 39, code: '/:bye', regcode: '/:bye', regtext: '\\[再见\\]' },
    { text: '汗', index: 40, code: '/:wipe', regcode: '/:wipe', regtext: '\\[汗\\]' },
    { text: '抠鼻', index: 41, code: '/:dig', regcode: '/:dig', regtext: '\\[抠鼻\\]' },
    { text: '鼓掌', index: 42, code: '/:handclap', regcode: '/:handclap', regtext: '\\[鼓掌\\]' },
    { text: '糗', index: 43, code: '/:&-(', regcode: '/:&\\-\\(', regtext: '\\[糗\\]' },
    { text: '坏笑', index: 44, code: '/:B-)', regcode: '/:B\\-\\)', regtext: '\\[坏笑\\]' },
    { text: '左哼哼', index: 45, code: '/:<@', regcode: '/:<@', regtext: '\\[左哼哼\\]' },
    { text: '右哼哼', index: 46, code: '/:@>', regcode: '/:@>', regtext: '\\[右哼哼\\]' },
    { text: '哈欠', index: 47, code: '/::-O', regcode: '/::\\-O', regtext: '\\[哈欠\\]' },
    { text: '鄙视', index: 48, code: '/:>-|', regcode: '/:>\\-\\|', regtext: '\\[鄙视\\]' },
    { text: '委屈', index: 49, code: '/:P-(', regcode: '/:P\\-\\(', regtext: '\\[委屈\\]' },
    { text: '难过', index: 50, code: "/::'|", regcode: "/::'\\|", regtext: '\\[难过\\]' },
    { text: '奸笑', index: 51, code: '/:X-)', regcode: '/:X\\-\\)', regtext: '\\[奸笑\\]' },
    { text: '亲亲', index: 52, code: '/::*', regcode: '/::\\*', regtext: '\\[亲亲\\]' },
    { text: '吓', index: 53, code: '/:@x', regcode: '/:@x', regtext: '\\[吓\\]' },
    { text: '可怜', index: 54, code: '/:8*', regcode: '/:8\\*', regtext: '\\[可怜\\]' },
    { text: '菜刀', index: 55, code: '/:pd', regcode: '/:pd', regtext: '\\[菜刀\\]' },
    { text: '西瓜', index: 56, code: '/:<W>', regcode: '/:<W>', regtext: '\\[西瓜\\]' },
    { text: '啤酒', index: 57, code: '/:beer', regcode: '/:beer', regtext: '\\[啤酒\\]' },
    { text: '篮球', index: 58, code: '/:basketb', regcode: '/:basketb', regtext: '\\[篮球\\]' },
    { text: '乒乓', index: 59, code: '/:oo', regcode: '/:oo', regtext: '\\[乒乓\\]' },
    { text: '咖啡', index: 60, code: '/:coffee', regcode: '/:coffee', regtext: '\\[咖啡\\]' },
    { text: '饭', index: 61, code: '/:eat', regcode: '/:eat', regtext: '\\[饭\\]' },
    { text: '猪头', index: 62, code: '/:pig', regcode: '/:pig', regtext: '\\[猪头\\]' },
    { text: '鲜花', index: 63, code: '/:rose', regcode: '/:rose', regtext: '\\[鲜花\\]' },
    { text: '枯萎', index: 64, code: '/:fade', regcode: '/:fade', regtext: '\\[枯萎\\]' },
    { text: '红唇', index: 65, code: '/:showlove', regcode: '/:showlove', regtext: '\\[红唇\\]' },
    { text: '爱心', index: 66, code: '/:heart', regcode: '/:heart', regtext: '\\[爱心\\]' },
    { text: '心碎', index: 67, code: '/:break', regcode: '/:break', regtext: '\\[心碎\\]' },
    { text: '蛋糕', index: 68, code: '/:cake', regcode: '/:cake', regtext: '\\[蛋糕\\]' },
    { text: '闪电', index: 69, code: '/:li', regcode: '/:li', regtext: '\\[闪电\\]' },
    { text: '炸弹', index: 70, code: '/:bome', regcode: '/:bome', regtext: '\\[炸弹\\]' },
    { text: '刀', index: 71, code: '/:kn', regcode: '/:kn', regtext: '\\[刀\\]' },
    { text: '足球', index: 72, code: '/:footb', regcode: '/:footb', regtext: '\\[足球\\]' },
    { text: '瓢虫', index: 73, code: '/:ladybug', regcode: '/:ladybug', regtext: '\\[瓢虫\\]' },
    { text: '便便', index: 74, code: '/:shit', regcode: '/:shit', regtext: '\\[便便\\]' },
    { text: '晚安', index: 75, code: '/:moon', regcode: '/:moon', regtext: '\\[晚安\\]' },
    { text: '太阳', index: 76, code: '/:sun', regcode: '/:sun', regtext: '\\[太阳\\]' },
    { text: '礼物', index: 77, code: '/:gift', regcode: '/:gift', regtext: '\\[礼物\\]' },
    { text: '抱抱', index: 78, code: '/:hug', regcode: '/:hug', regtext: '\\[抱抱\\]' },
    { text: '赞', index: 79, code: '/:strong', regcode: '/:strong', regtext: '\\[赞\\]' },
    { text: '差劲', index: 80, code: '/:weak', regcode: '/:weak', regtext: '\\[差劲\\]' },
    { text: '握手', index: 81, code: '/:share', regcode: '/:share', regtext: '\\[握手\\]' },
    { text: 'yeah', index: 82, code: '/:v', regcode: '/:v', regtext: '\\[yeah\\]' },
    { text: '抱拳', index: 83, code: '/:@)', regcode: '/:@\\)', regtext: '\\[抱拳\\]' },
    { text: '勾引', index: 84, code: '/:jj', regcode: '/:jj', regtext: '\\[勾引\\]' },
    { text: '力量', index: 85, code: '/:@@', regcode: '/:@@', regtext: '\\[力量\\]' },
    { text: '坏', index: 86, code: '/:bad', regcode: '/:bad', regtext: '\\[坏\\]' },
    { text: '爱你', index: 87, code: '/:lvu', regcode: '/:lvu', regtext: '\\[爱你\\]' },
    { text: 'NO', index: 88, code: '/:no', regcode: '/:no', regtext: '\\[NO\\]' },
    { text: 'OK', index: 89, code: '/:ok', regcode: '/:ok', regtext: '\\[OK\\]' },
    { text: '爱', index: 90, code: '/:love', regcode: '/:love', regtext: '\\[爱\\]' },
    { text: '亲吻', index: 91, code: '/:<L>', regcode: '/:<L>', regtext: '\\[亲吻\\]' },
    { text: '跳舞', index: 92, code: '/:jump', regcode: '/:jump', regtext: '\\[跳舞\\]' },
    { text: '害怕', index: 93, code: '/:shake', regcode: '/:shake', regtext: '\\[害怕\\]' },
    { text: '尖叫', index: 94, code: '/:<O>', regcode: '/:<O>', regtext: '\\[尖叫\\]' },
    { text: '圈', index: 95, code: '/:circle', regcode: '/:circle', regtext: '\\[圈\\]' },
    { text: '拜', index: 96, code: '/:kotow', regcode: '/:kotow', regtext: '\\[拜\\]' },
    { text: '回头', index: 97, code: '/:turn', regcode: '/:turn', regtext: '\\[回头\\]' },
    { text: '跳', index: 98, code: '/:skip', regcode: '/:skip', regtext: '\\[跳\\]' },
    { text: '挥手', index: 99, code: '/:oY', regcode: '/:o\\Y', regtext: '\\[挥手\\]' },
    { text: '激动', index: 100, code: '/:#-0', regcode: '/:#\\-0', regtext: '\\[激动\\]' },
    // { text: "街舞", clz: "wechat-emoji101", code: "[街舞]", regcode: "[街舞]" },
    // { text: '街舞', index: 101, code: '/:hiphot', regcode: '/:hiphot', regtext: '\\[街舞\\]' },
    { text: '吻', index: 102, code: '/:kiss', regcode: '/:kiss', regtext: '\\[吻\\]' },
    // { text: '旋转', index: 103, code: '/:<&', regcode: '/:<&', regtext: '\\[旋转\\]' },
    { text: '太极', index: 104, code: '/:&>', regcode: '/:&>', regtext: '\\[太极\\]' },
];

function replaceWechatEmotions(text, isFeishu = false) {
    emojiCodes.forEach((item, index) => {
        var reg = new RegExp(item.regcode, 'g');
        // eslint-disable-next-line no-useless-concat
        let str = '<span class="qa-wechat-emoji ' + 'qa-wechat-emoji' + item.index + '"></span>';
        text = text && text.replace?.(reg, str);
    });

    if (isFeishu) {
        text = replaceFeishuEmotions(text);
    } else {
        text = replaceWechatNewEmotions(text);
    }

    return text;
}

function replaceWechatEmotionsInRich(text, isFeishu = false) {
    emojiCodes.forEach((item, index) => {
        var reg = new RegExp(
            `<span class=\\"wechat-emoji wechat-emoji${item.index}\\"></span>`,
            'g'
        );
        // eslint-disable-next-line no-useless-concat
        let str = '<span class="qa-wechat-emoji ' + 'qa-wechat-emoji' + item.index + '"></span>';
        text = text && text.replace?.(reg, str);
    });

    if (isFeishu) {
        text = replaceFeishuEmotions(text);
    } else {
        text = replaceWechatNewEmotions(text);
    }

    return text;
}

const emojiJson = {
    '[微笑]': 'smiley_0',
    '[撇嘴]': 'smiley_1',
    '[色]': 'smiley_2',
    '[发呆]': 'smiley_3',
    '[得意]': 'smiley_4',
    '[流泪]': 'smiley_5',
    '[害羞]': 'smiley_6',
    '[闭嘴]': 'smiley_7',
    '[睡]': 'smiley_8',
    '[大哭]': 'smiley_9',
    '[尴尬]': 'smiley_10',
    '[发怒]': 'smiley_11',
    '[调皮]': 'smiley_12',
    '[呲牙]': 'smiley_13',
    '[惊讶]': 'smiley_14',
    '[难过]': 'smiley_15',
    '[冷汗]': 'smiley_17',
    '[抓狂]': 'smiley_18',
    '[吐]': 'smiley_19',
    '[偷笑]': 'smiley_20',
    '[愉快]': 'smiley_21',
    '[白眼]': 'smiley_22',
    '[傲慢]': 'smiley_23',
    '[困]': 'smiley_25',
    '[惊恐]': 'smiley_26',
    '[流汗]': 'smiley_27',
    '[憨笑]': 'smiley_28',
    '[悠闲]': 'smiley_29',
    '[奋斗]': 'smiley_30',
    '[咒骂]': 'smiley_31',
    '[疑问]': 'smiley_32',
    '[嘘]': 'smiley_33',
    '[晕]': 'smiley_34',
    '[衰]': 'smiley_36',
    '[骷髅]': 'smiley_37',
    '[敲打]': 'smiley_38',
    '[再见]': 'smiley_39',
    '[擦汗]': 'smiley_40',
    '[抠鼻]': 'smiley_41',
    '[鼓掌]': 'smiley_42',
    '[坏笑]': 'smiley_44',
    '[左哼哼]': 'smiley_45',
    '[右哼哼]': 'smiley_46',
    '[哈欠]': 'smiley_47',
    '[鄙视]': 'smiley_48',
    '[委屈]': 'smiley_49',
    '[快哭了]': 'smiley_50',
    '[阴险]': 'smiley_51',
    '[亲亲]': 'smiley_52',
    '[可怜]': 'smiley_54',
    '[菜刀]': 'smiley_55',
    '[西瓜]': 'smiley_56',
    '[啤酒]': 'smiley_57',
    '[咖啡]': 'smiley_60',
    '[饭]': 'smiley_61',
    '[猪头]': 'smiley_62',
    '[玫瑰]': 'smiley_63',
    '[凋谢]': 'smiley_64',
    '[嘴唇]': 'smiley_65',
    '[爱心]': 'smiley_66',
    '[心碎]': 'smiley_67',
    '[炸弹]': 'smiley_70',
    '[便便]': 'smiley_74',
    '[月亮]': 'smiley_75',
    '[太阳]': 'smiley_76',
    '[礼物]': 'u1F381',
    '[拥抱]': 'smiley_78',
    '[强]': 'smiley_79',
    '[弱]': 'smiley_80',
    '[握手]': 'smiley_81',
    '[胜利]': 'smiley_82',
    '[抱拳]': 'smiley_83',
    '[勾引]': 'smiley_84',
    '[拳头]': 'smiley_85',
    '[OK]': 'smiley_89',
    '[跳跳]': 'smiley_92',
    '[发抖]': 'smiley_93',
    '[怄火]': 'smiley_94',
    '[转圈]': 'smiley_95',
    '[嘿哈]': 'e2_04',
    '[捂脸]': 'e2_05',
    '[奸笑]': 'e2_02',
    '[机智]': 'e2_06',
    '[皱眉]': 'e2_12',
    '[耶]': 'e2_11',
    '[红包]': 'e2_09',
    '[發]': 'e2_09',
    '[福]': 'e2_09',
    '[鸡]': 'e2_14',
    '[笑脸]': 'u1F604',
    '[生病]': 'u1F637',
    '[破涕为笑]': 'u1F602',
    '[吐舌]': 'u1F61D',
    '[脸红]': 'u1F633',
    '[恐惧]': 'u1F631',
    '[失望]': 'u1F614',
    '[无语]': 'u1F612',
    '[鬼魂]': 'u1F47B',
    '[合十]': 'u1F64F',
    '[强壮]': 'u1F4AA',
    '[庆祝]': 'u1F389',
    '[吃瓜]': 'smiley_313',
    '[加油]': 'smiley_314',
    '[汗]': 'smiley_315',
    '[天啊]': 'smiley_316',
    '[Emm]': 'smiley_317',
    '[社会社会]': 'smiley_318',
    '[旺柴]': 'smiley_319',
    '[好的]': 'smiley_320',
    '[打脸]': 'smiley_321',
    '[哇]': 'smiley_322',
    '[囧]': 'smiley_17',
};

const replaceWechatNewEmotions = (str) => {
    if (!str) {
        return;
    }

    let pattern = /\[.*?\]/g;
    str = str.replace(pattern, (match) => {
        console.log(match, emojiJson[match]);
        if (emojiJson[match]) {
            return `<span class="qa-qqface ${emojiJson[match]}"></span>`;
        } else {
            return match;
        }
    });
    return str;
};

const feishuEmojiJson = {
    '[OK]': 'OK',
    '[赞]': 'THUMBSUP',
    '[双手合十]': 'THANKS',
    '[加油]': 'MUSCLE',
    '[比心]': 'FINGERHEART',
    '[鼓掌]': 'APPLAUSE',
    '[碰拳]': 'FISTBUMP',
    '[+1]': 'JIAYI',
    '[完成]': 'DONE',
    '[微笑]': 'SMILE',
    '[愉快]': 'Delighted',
    '[笑容满面]': 'BeamingFace',
    '[呲牙]': 'BLUSH',
    '[大笑]': 'LAUGH',
    '[坏笑]': 'SMIRK',
    '[笑哭]': 'LOL',
    '[捂脸]': 'FACEPALM',
    '[送心]': 'LOVE',
    '[调皮]': 'WINK',
    '[得意]': 'PROUD',
    '[灵光一闪]': 'WITTY',
    '[机智]': 'SMART',
    '[惊呆]': 'SCOWL',
    '[思考]': 'THINKING',
    '[流泪]': 'SOB',
    '[泣不成声]': 'CRY',
    '[黑线]': 'ERROR',
    '[抠鼻]': 'NOSEPICK',
    '[烦躁]': 'HAUGHTY',
    '[打脸]': 'SLAP',
    '[吐血]': 'SPITBLOOD',
    '[衰]': 'TOASTED',
    '[冷汗]': 'ColdSweat',
    // '[新月脸]': 'FullMoonFace',
    '[满月脸]': 'FullMoonFace',
    '[看]': 'GLANCE',
    '[呆无辜]': 'DULL',
    '[玫瑰]': 'ROSE',
    '[爱心]': 'HEART',
    '[撒花]': 'PARTY',
    '[无辜笑]': 'INNOCENTSMILE',
    '[害羞]': 'SHY',
    '[偷笑]': 'CHUCKLE',
    '[笑]': 'JOYFUL',
    '[惊喜]': 'WOW',
    '[嬉笑]': 'TRICK',
    '[耶]': 'YEAH',
    '[我想静静]': 'ENOUGH',
    '[泪奔]': 'TEARS',
    '[尬笑]': 'EMBARRASSED',
    '[亲亲]': 'KISS',
    '[飞吻]': 'SMOOCH',
    '[爱慕]': 'DROOL',
    '[心心脸]': 'OBSESSED',
    '[财迷]': 'MONEY',
    '[做鬼脸]': 'TEASE',
    '[酷]': 'SHOWOFF',
    '[摸头]': 'COMFORT',
    '[欢呼]': 'CLAP',
    '[强]': 'PRAISE',
    '[奋斗]': 'STRIVE',
    '[脸红]': 'XBLUSH',
    '[闭嘴]': 'SILENT',
    '[再见]': 'WAVE',
    '[什么？]': 'WHAT',
    '[皱眉]': 'FROWN',
    '[晕]': 'DIZZY',
    '[鄙视]': 'LOOKDOWN',
    '[大哭]': 'WAIL',
    '[抓狂]': 'CRAZY',
    '[可怜]': 'WHIMPER',
    '[求抱抱]': 'HUG',
    '[快哭了]': 'BLUBBER',
    '[委屈]': 'WRONGED',
    '[翻白眼]': 'HUSKY',
    '[嘘]': 'SHHH',
    '[撇嘴]': 'SMUG',
    '[发怒]': 'ANGRY',
    '[敲打]': 'HAMMER',
    '[震惊]': 'SHOCKED',
    '[惊恐]': 'TERROR',
    '[石化]': 'PETRIFIED',
    '[骷髅]': 'SKULL',
    '[汗]': 'SWEAT',
    '[无语]': 'SPEECHLESS',
    '[酣睡]': 'SLEEP',
    '[困]': 'DROWSY',
    '[哈欠]': 'YAWN',
    '[戴口罩]': 'SICK',
    '[吐]': 'PUKE',
    '[背叛]': 'BETRAYED',
    '[听歌]': 'HEADSET',
    '[吃饭]': 'EatingFood',
    '[敲键盘]': 'Typing',
    '[柠檬]': 'Lemon',
    '[了解]': 'Get',
    '[我看行]': 'LGTM',
    '[在做了]': 'OnIt',
    '[稍等]': 'OneSecond',
    '[叹气]': 'Sigh',
    '[举手]': 'MeMeMe',
    '[VR]': 'VRHeadset',
    '[派对]': 'Partying',
    '[冲]': 'GoGoGo',
    '[感谢]': 'ThanksFace',
    '[致敬]': 'SaluteFace',
    '[耸肩摊手]': 'Shrug',
    '[送你小红花]': 'YouAreTheBest',
    '[抱拳]': 'SALUTE',
    '[握手]': 'SHAKE',
    '[击掌]': 'HIGHFIVE',
    // '[挥手]': 'HIGHFIVE',
    '[点击]': 'UPPERLEFT',
    '[踩]': 'ThumbsDown',
    '[小臭脸]': 'ClownFace',
    '[白眼]': 'SLIGHT',
    '[吐舌]': 'TONGUE',
    '[不看]': 'EYESCLOSED',
    '[啊？]': 'BEAR',
    '[公牛]': 'BULL',
    '[小牛]': 'CALF',
    '[猛虎打Call]': 'RoarForYou',
    '[欢兔喝彩]': 'JubilantRabbit',
    '[龙光焕发]': 'HappyDragon',
    '[嘴唇]': 'LIPS',
    '[啤酒]': 'BEER',
    '[蛋糕]': 'CAKE',
    '[礼物]': 'GIFT',
    '[胡瓜]': 'CUCUMBER',
    '[鸡腿]': 'Drumstick',
    '[辣椒]': 'Pepper',
    '[冰糖葫芦]': 'CANDIEDHAWS',
    '[奶茶]': 'BubbleTea',
    '[咖啡]': 'Coffee',
    '[Yes]': 'Yes',
    '[No]': 'No',
    '[OKR]': 'OKR',
    '[勾号]': 'CheckMark',
    '[叉号]': 'CrossMark',
    '[-1]': 'MinusOne',
    '[100分]': 'Hundred',
    '[牛]': 'AWESOMEN',
    '[图钉]': 'Pin',
    '[闹钟]': 'Alarm',
    '[喇叭]': 'Loudspeaker',
    '[奖杯]': 'Trophy',
    '[火]': 'Fire',
    '[彩虹]': 'RAINBOWPUKE',
    '[音乐]': 'Music',
    '[电视]': 'TV',
    '[电影]': 'Movie',
    '[南瓜灯]': 'Pumpkin',
    '[圣诞树]': 'XmasTree',
    '[雪人]': 'Snowman',
    '[圣诞帽]': 'XmasHat',
    '[烟花]': 'FIREWORKS',
    // '[2025]': 'FIREWORKS',
    // '[巳巳如意]': 'FIREWORKS',
    '[红包]': 'REDPACKET',
    '[发]': 'FORTUNE',
    '[福]': 'LUCK',
    '[爆竹]': 'FIRECRACKER',
    '[元宵]': 'StickyRiceBalls',
    '[月饼]': 'Mooncake',
    '[玉兔]': 'MoonRabbit',
    '[心碎]': 'HEARTBROKEN',
    '[炸弹]': 'BOMB',
    '[便便]': 'POOP',
    '[18禁]': '_18x',
    '[刀]': 'CLEAVER',
    '[足球]': 'Soccer',
    '[篮球]': 'Basketball',
    '[请勿打扰]': 'GeneralDoNotDisturb',
    '[思考中]': 'Status_PrivateMessage',
    '[日程]': 'GeneralInMeetingBusy',
    '[精神补给]': 'StatusReading',
    '[灵光一现]': 'StatusFlashOfInspiration',
    '[出差]': 'GeneralBusinessTrip',
    '[在家办公]': 'GeneralWorkFromHome',
    '[美好生活]': 'StatusEnjoyLife',
    '[出行]': 'GeneralTravellingCar',
    '[公交车]': 'StatusBus',
    '[飞行中]': 'StatusInFlight',
    '[辛勤营业]': 'GeneralSun',
    '[天色已晚]': 'GeneralMoonRest',
};

const replaceFeishuEmotions = (str) => {
    if (!str) {
        return;
    }

    let pattern = /\[.*?\]/g;
    str = str.replace(pattern, (match) => {
        console.log(match, feishuEmojiJson[match]);
        if (feishuEmojiJson[match]) {
            return `<span class="feishu-emoji ${feishuEmojiJson[match]}"></span>`;
        } else {
            return match;
        }
    });
    return str;
};

export default {
    replaceWechatEmotions,
    replaceWechatEmotionsInRich,
};
